<template>
  <default-layout>
    <v-layout wrap>
      <v-flex xs12>
        <categories-menu-bar></categories-menu-bar>
      </v-flex>

      <v-flex xs12 v-if="categories" class="pt-4">
        <categories-table :categories="categories"></categories-table>
      </v-flex>
    </v-layout>

    <v-btn fab fixed bottom right dark class="primary" to="/categories/create">
      <v-icon>add</v-icon>
    </v-btn>
  </default-layout>
</template>


<script>
import CategoriesMenuBar from "./_components/categories_menu.vue";
import CategoriesTable from "./_components/categories_table.vue";

export default {
  name: "CategoriesIndexPage",
  components: {
    CategoriesMenuBar,
    CategoriesTable
  },
  data() {
    return {
      categories: null
    };
  },
  methods: {
  
  },
  created() {
    this.$store.dispatch("get", "/expertise").then(res => {
      this.categories = res.expertiseCategories;
    });
  }
};
</script>
